import type { FaireProductEntity } from "../../entity_types/product";

export const p_j2kpsg4u7z: FaireProductEntity = {
  token: "p_j2kpsg4u7z",
  type: "product",
  name: "Highland Cow Squishy Toy",
  brandToken: "b_r56bdd4kh8",
  brandName: "Nash Grey",
  imageUrl:
    "https://cdn.faire.com/fastly/f6bb3fae7f84d87f9ee3c1b2e1e73c0aa3562017106c704325006b4ec572ef6f.png",
  galleryImageUrls: [],
  priceDollars: 4.25,
  description:
    'Bring a touch of the Scottish Highlands straight to your desk with this ultra-cute Highland Cow Squishy Toy! Featuring the iconic shaggy coat, signature black horns, and an adorable yellow muzzle, this little coo is ready to melt your heart and soothe your stress away.\n\nApproximately 3.15"x2.36"x1.97”\n\nTPR Squishy Material\n\nPlease note that we cannot cancel these orders as they are ordered per submitted pre-orders.\n\nETA is the estimated time of arrival to us - please be mindful that these are estimated arrival dates and we do not guarantee any items by a specific date. Unfortunately, shipping and production delays sometimes occur and are out of our control.\n',
  tags: [],
  msrpDollars: 8.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:42.867Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
